import { Fragment } from "react";

import { css } from "@emotion/react";

import { colors, InfoIcon } from "@dotnet/telematics-design-system";

import { svgFontSize } from "shared";

import { TOOLTIP_PLACEMENT, TooltipGeneral } from "../Tooltips";
import { LabelProps } from "./types";

const Label = ({
    titleLeft,
    titleTooltip,
    titleRight,
    isRequired,
    ...props
}: LabelProps) => {
    const { blue700, gray700 } = colors;

    const getJustifyPosition = () => {
        if (titleLeft && titleRight) {
            return "space-between";
        }

        return titleLeft ? "flex-start" : "flex-end";
    };

    const justifyContent = getJustifyPosition();

    return (
        <div
            {...props}
            css={css({
                display: "flex",
                justifyContent,
                alignItems: "center",
                marginBottom: "4px",
                color: gray700,
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                letterSpacing: "0.1px"
            })}
        >
            {titleLeft && (
                <div
                    css={css({
                        display: "flex",
                        alignItems: "center"
                    })}
                >
                    <span>{titleLeft}</span>

                    {isRequired && <Fragment>&#42;</Fragment>}

                    {titleTooltip && (
                        <TooltipGeneral
                            title={titleTooltip}
                            placement={TOOLTIP_PLACEMENT.Top}
                        >
                            <span
                                css={css({
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "4px",

                                    "& > svg": {
                                        color: blue700,
                                        ...svgFontSize(16)
                                    }
                                })}
                            >
                                <InfoIcon />
                            </span>
                        </TooltipGeneral>
                    )}
                </div>
            )}

            {titleRight && <div>{titleRight}</div>}
        </div>
    );
};

export default Label;
